import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import Store from '@ember-data/store';
import AdminFundGroupModel from 'donor-elf-web/models/admin/fund-group';

export interface FundGroupsIndexRouteModel {
  fundGroups: AdminFundGroupModel[];
}

export default class FundGroupsIndexRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Fund Groups';
  }

  async model(): Promise<FundGroupsIndexRouteModel> {
    let fundGroups = (await this.store.query('admin/fund-group', {})).slice();
    return {
      fundGroups: sortByProperties(fundGroups, ['name:asc']),
    };
  }
}
